import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { Scroller } from '@ta-interaktiv/react-scroller'
import { Melting_DE, Melting_FR } from 'components/Localization/Melting'
import { useWindowSize } from 'usehooks-ts'

import Melting_1 from './images/Melting_1.png'
import Melting_2 from './images/Melting_2.png'
import Melting_3 from './images/Melting_3.png'
import Melting_4 from './images/Melting_4.png'
import Melting_5 from './images/Melting_5.png'

const Images = [Melting_1, Melting_2, Melting_3, Melting_4, Melting_5]
// const Images = [...Array(5)].map((num, index) =>
//   require('../Melting/images/Melting_' + (index + 1) + '.png')
// )

export const Melting = ({ lang = 'de' }: { lang?: 'de' | 'fr' }) => {
  const [screenHeight, setScreenHeight] = useState<number>(0)
  const { width, height } = useWindowSize()
  useEffect(() => {
    setScreenHeight(height * 0.7)
  }, [width])

  const texts = lang === 'fr' ? Melting_FR : Melting_DE
  return (
    <div>
      <Scroller
        front={texts.map((m) => (
          <FrontElement>
            <Title>{m[0]}</Title>
            <Text>{m[1]}</Text>
          </FrontElement>
        ))}
        back={(index: number, i: number) => {
          if (index < 0) index = 0
          if (index > 4) index = 4

          return (
            <>
              {height && (
                <BackElement height={screenHeight}>
                  <img src={Images[index]} />
                </BackElement>
              )}
            </>
          )
        }}
      />
    </div>
  )
}

const FrontElement = styled.div<{
  distanceTop?: number
  distanceBottom?: 'number'
}>`
  padding: 30px;
  padding-bottom: 30px;
  max-width: 80%;
  background-color: var(--site-background);
  text-align: left;
  font-family: var(--font-noto);
  -webkit-box-shadow: 0px 0px 7px 5px rgba(0, 0, 0, 0.1),
    0px 0px 7px 5px rgba(255, 255, 255, 0.1);
  box-shadow: 0px 0px 7px 5px rgba(0, 0, 0, 0.1),
    0px 0px 7px 5px rgba(255, 255, 255, 0.1); ;
`

const BackElement = styled.div<{
  height: number
  distanceTop?: number
  distanceBottom?: 'number'
}>`
  img {
    width: 100%;
    max-width: 100%;
    /* margin-left: -20%; */
  }
  display: flex;
  align-items: center;
  height: ${({ height }) => height + 'px'};
`

const Title = styled.h4`
  font-weight: 700;
  font-size: 22px;

  margin: 0;
  margin-bottom: 0.5em;
`
const Text = styled.div``
